module.exports = __webpack_public_path__ + "static/media/Sale.d69b4d64.svg";